import React from "react";
import { Link } from "react-router-dom";

// Native Russo One "Zelo" wordmark — no images, no white-box artifacts, scales perfectly.
export default function ZeloLogo({
  variant = "brand", // 'brand' | 'white'
  size = "md", // 'sm' | 'md' | 'lg' | 'xl'
  to = "/",
  className = "",
}) {
  const sizes = {
    sm: "text-2xl",
    md: "text-3xl md:text-4xl",
    lg: "text-4xl md:text-5xl",
    xl: "text-5xl md:text-6xl",
  };
  const color = variant === "white" ? "text-white" : "text-brand";
  const cls = `font-russo leading-none tracking-tight inline-block select-none ${color} ${sizes[size] || sizes.md} ${className}`;

  if (to === false) return <span className={cls}>Zelo</span>;
  return (
    <Link to={to} className={cls} data-testid="zelo-logo">Zelo</Link>
  );
}
